import { Plugin } from "plugin";
import SDJournal from "sd-journal";

function getLog(journal) {
  
  var ISOString;
  try {
  var usec = parseInt(journal.get_data("_SOURCE_REALTIME_TIMESTAMP").replace("_SOURCE_REALTIME_TIMESTAMP=", ""));
  var msec = parseInt(usec/1000);
  ISOString = new Date(msec).toISOString();
  } catch(e) {
    ISOString = "1970-01-01T00:00:00Z";
  }

  return {
    PRIORITY: {
      "0": "err",
      "1": "err",
      "2": "err",
      "3": "err",
      "4": "warning",
      "5": "warning",
      "6": "info",
      "7": "debug",
    }[journal.get_data("PRIORITY").replace("PRIORITY=", "")],
    MESSAGE: journal.get_data("MESSAGE").replace("MESSAGE=", ""),   
    ISODATE: ISOString,
    cursor: journal.get_cursor()
  };  
}

class JournalService extends Plugin {
  constructor(...args) {
    super(...args);
  }
  __sdjournal_follow_onchange() {
    var advance = this.__sdjournal_follow.next();
    
    if (advance) {       
       //clients.notifyAll("RM_log", getLog(this.__sdjournal_follow));
    }
  }
  async start(...args) {
    await super.start?.(...args);

    this.__sdjournal = new SDJournal();
    this.__sdjournal.open();
    this.__sdjournal.add_match("_SYSTEMD_UNIT=biocore@server.service");        

    this.__sdjournal_follow = new SDJournal();
    this.__sdjournal_follow.open();
    this.__sdjournal_follow.add_match("_SYSTEMD_UNIT=biocore@server.service");    
    this.__sdjournal_follow.seek_tail();
    this.__sdjournal_follow.previous_skip(BigInt(0));
    this.__sdjournal_follow.onchange = this.__sdjournal_follow_onchange.bind(this);    
  }
  async stop(...args) {
    await super.stop?.(...args);
    
    this.__sdjournal.close();
    this.__sdjournal_follow.close();        
  }
  async RM_syslog_search(request, string, num=20) {
    this.__sdjournal.seek_tail();
    this.__sdjournal.previous();
    this.__sdjournal.next();
    var logs = [];
    for (var i=0;i<num;i++) {
      logs.push(getLog(this.__sdjournal));
      if (!this.__sdjournal.previous()) break;
    }
    return logs;
  }
  //get logs from cursor position, the log entry at cursor postion it not included
  async RM_syslog_getlogs(request, cursor, num=20) {      
    let logs = [];
    if (num==0) return(logs);
            
    if (cursor=="") {
      this.__sdjournal.seek_tail();
    } else {
      this.__sdjournal.seek_cursor(cursor);
    }
    this.__sdjournal.previous_skip(BigInt(0));
        
    for (let i=0, n=Math.abs(num), d=Math.sign(num);i<n;i++) {      
      if (d>0) {
        if (!this.__sdjournal.next()) break;
      } else {
        if (!this.__sdjournal.previous()) break;        
      }
      logs.push(getLog(this.__sdjournal));
    }
    
    return logs;
  }  
}

export default JournalService;